import { buildGeneralTab, buildValidateTab, showWidgetEditDialog } from '@juvare/common-form-ui/WidgetEditDialog';
import { buildValuesTab } from '@juvare/common-form-ui/WidgetEditDialog/buildValuesTab';
import { FormHelperErrorDescription } from '@juvare/common-form-ui/WidgetForm/Components';
import { defaultWidgetLabelProvider, getVisibleError, handleWidgetUpdate, renderForm, validateCustom, } from '@juvare/common-form-ui/WidgetForm/Utils';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import PagerOutlinedIcon from '@juvare/common-web-ui/icons/PagerOutlined';
import { BaseWidgetEditorComponent } from '@juvare/widget-ui/BaseWidgetEditorComponent';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import FaxOutlinedIcon from '@mui/icons-material/FaxOutlined';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PhoneEnabledOutlinedIcon from '@mui/icons-material/PhoneEnabledOutlined';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Box, ButtonBase, Card, FormControl, Grid, Typography } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../hooks';
import { type } from './types';
const DeliveryMethods = (props) => {
    var _a;
    const { t } = useAlertUiTranslation();
    const value = props.getDataArray() || [];
    const error = getVisibleError(props);
    const channelIcon = {
        email: React.createElement(MailOutlinedIcon, null),
        voice: React.createElement(PhoneEnabledOutlinedIcon, null),
        sms: React.createElement(SmsOutlinedIcon, null),
        fax: React.createElement(FaxOutlinedIcon, null),
        pager: React.createElement(PagerOutlinedIcon, null),
        whatsapp: React.createElement(WhatsAppIcon, null),
        inbox: React.createElement(InboxOutlinedIcon, null),
        push: React.createElement(NotificationsIcon, null),
    };
    const setChannel = (channel, deselected) => {
        const result = deselected ? value.filter((c) => c !== channel) : value.concat(channel);
        props.setData(result);
        renderForm(props, { changed: true });
    };
    return (React.createElement(FormControl, { fullWidth: true, error: !!error },
        React.createElement(Box, { sx: { flexGrow: 1, pt: 0 } },
            React.createElement(Grid, { container: true, spacing: 2, sx: { maxWidth: '100%', display: 'row', justifyContent: 'flex-start', alignItems: 'center' } }, (_a = props.config.values) === null || _a === void 0 ? void 0 : _a.map((channel) => {
                var _a, _b, _c, _d, _e, _f;
                const selected = value && value.includes(channel.value);
                return (React.createElement(Grid, { key: channel.value, size: {
                        xs: 6,
                        sm: 3,
                        md: 4,
                        lg: 3,
                        xl: 1.7,
                    } },
                    React.createElement(ButtonBase, { onClick: !channel.disabled && !((_a = props.config) === null || _a === void 0 ? void 0 : _a.disabled) ? () => setChannel(channel.value, selected) : undefined, sx: {
                            display: 'block',
                            minWidth: '100%',
                            borderColor: channel.disabled && selected
                                ? (theme) => theme.palette.grey['400']
                                : selected
                                    ? (theme) => theme.palette.primary.main
                                    : undefined,
                            color: (theme) => theme.palette.primary.main,
                            pointerEvents: channel.disabled || ((_b = props.config) === null || _b === void 0 ? void 0 : _b.disabled) ? 'none' : 'auto',
                        }, "data-test": `select-${channel.label.toLowerCase()}-channel-button`, focusRipple: true, role: 'checkbox', "aria-checked": selected, "aria-readonly": channel.disabled || ((_c = props.config) === null || _c === void 0 ? void 0 : _c.disabled), "aria-label": channel.disabled || ((_d = props.config) === null || _d === void 0 ? void 0 : _d.disabled)
                            ? t('widget.mandatoryChannelAriaLabel', { channel: channel.label })
                            : undefined },
                        React.createElement(Card, { variant: 'outlined', "data-test": 'channel-card', sx: {
                                height: 104,
                                borderColor: (channel.disabled || ((_e = props.config) === null || _e === void 0 ? void 0 : _e.disabled)) && selected
                                    ? (theme) => theme.palette.grey['400']
                                    : selected
                                        ? (theme) => theme.palette.primary.main
                                        : error
                                            ? (theme) => theme.palette.error.main
                                            : undefined,
                                color: (theme) => theme.palette.primary.main,
                                borderWidth: selected ? '2px' : '1px',
                                display: 'flex',
                                justifyContent: 'center',
                            } },
                            React.createElement(Box, { sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexDirection: 'column',
                                } },
                                React.createElement(Box, { sx: { position: 'absolute', top: 8, right: 8 } }, selected && !channel.disabled && !((_f = props.config) === null || _f === void 0 ? void 0 : _f.disabled) ? (React.createElement(CheckCircleIcon, { color: 'success', fontSize: 'small' })) : selected ? (React.createElement(CheckCircleIcon, { sx: { color: (theme) => theme.palette.grey['400'] }, fontSize: 'small' })) : (React.createElement(CircleOutlinedIcon, { fontSize: 'small', sx: {
                                        color: (theme) => {
                                            var _a;
                                            return error
                                                ? theme.palette.error.main
                                                : ((_a = props.config) === null || _a === void 0 ? void 0 : _a.disabled)
                                                    ? theme.palette.grey['400']
                                                    : undefined;
                                        },
                                    } }))),
                                React.createElement(Box, { sx: {
                                        borderRadius: '50%',
                                        mx: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        p: 1,
                                        border: 1,
                                        borderColor: themeColors.border.main,
                                        color: themeColors.icon.subtle,
                                        mb: 2,
                                        mt: 1,
                                    } }, channelIcon[channel.value]),
                                React.createElement(Typography, { variant: 'subtitle2', sx: { mb: 1 } }, channel.label))))));
            }))),
        React.createElement(FormHelperErrorDescription, { error: error })));
};
const WidgetDeliveryMethodsEditor = (props) => {
    return (React.createElement(BaseWidgetEditorComponent, Object.assign({}, props, { widgetLabelProvider: defaultWidgetLabelProvider, onEditWidget: (endEditing) => showWidgetEditDialog(props, endEditing, { title: 'Delivery Methods' }, buildGeneralTab(props, { key: true }), buildValuesTab(props), buildValidateTab(props, { required: true })) }),
        React.createElement(DeliveryMethods, Object.assign({}, props))));
};
export const widgetDeliveryMethods = {
    type,
    createWidget: () => ({
        type,
        key: 'channels',
        values: [
            { value: 'email', label: 'Email' },
            { value: 'voice', label: 'Voice' },
            { value: 'sms', label: 'Text' },
            { value: 'fax', label: 'Fax' },
            { value: 'pager', label: 'Pager' },
            { value: 'whatsapp', label: 'WhatsApp' },
            { value: 'inbox', label: 'Inbox' },
        ],
    }),
    init: (props) => {
        const data = props.getData();
        if (data === null) {
            props.setData([]);
        }
    },
    validate: (props) => {
        var _a, _b;
        const value = props.getDataArray();
        if (((_a = props.config.validate) === null || _a === void 0 ? void 0 : _a.required) && !value.length) {
            return (_b = props.config.validate.requiredMessage) !== null && _b !== void 0 ? _b : 'Required';
        }
        return validateCustom(props, value);
    },
    update: handleWidgetUpdate,
    component: DeliveryMethods,
    icon: React.createElement(ForwardToInboxIcon, null),
    editorComponent: WidgetDeliveryMethodsEditor,
};
